import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>I'm FrontEnd Engineer.</h1>
            </header>
            <div className="content">
                <p>PWA and SPA by React.js<br></br>
                Full-stack development of WordPress site (Plannning,Direction,Setup AWS)
                </p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">GET STARTED</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
